import React from 'react';
import Styles from './styles/menuStyles';
import './styles/menuIcon.css';

const MenuIcon = (props) => (
  <button className="menuToggleContainer" id="menuToggleContainer" style={Styles.menuToggleContainer} onClick={props.handleDrawerToggle}>
    <div id="menuIcon" style={Styles.menuIconStyles}>
      <span></span>
      <span></span>
      <span></span>
      <span></span>
    </div>
    <div style={Styles.menuToggle} id="menuToggle" className="menuToggle closed">Menu</div>
  </button>
)

export default MenuIcon;